export default {
  // 页面标题和副标题
  'page.mainTitle': 'Unix时间戳转换器',
  'page.mainTitleSEO': 'Unix时间戳转换器 & 纪元时间工具',
  'page.subtitle': '在线快速转换Unix时间戳与日期时间',
  'page.title': '时间戳转换器',
  'page.currentTimestamp': '当前Unix时间戳',
  'page.currentEpochTime': '当前Unix纪元时间',
  'page.milliseconds': '毫秒（13位）',
  'page.seconds': '秒（10位）',
  'page.millisecondsOnly': '毫秒',
  'page.secondsOnly': '秒',
  'page.currentDateTime': '当前日期时间',

  // 交互式转换器
  'page.interactiveConverter': '交互式时间戳 ↔ 日期转换器',
  'page.timestampToDatetimeTitle': 'Unix时间戳转日期时间',
  'page.datetimeToTimestampTitle': '日期时间转时间戳',
  'page.ms': '毫秒',
  'page.sec': '秒',
  'page.autoDetect': '自动识别格式',
  'page.detected': '已识别',
  'page.digits': '位',
  'page.convertedTo': '转换为',
  'page.converterTip': '实时双向转换',
  'page.converterTipDesc': '在任一字段输入即可立即看到转换结果。自动识别10位（秒）或13位（毫秒）时间戳。',

  // 转换部分
  'page.timestampToDateTime': '时间戳转日期时间',
  'page.dateTimeToTimestamp': '日期时间转时间戳',
  'page.selectFormat': '选择格式',
  'page.enterTimestamp': '输入时间戳',
  'page.enterDateTime': '选择日期和时间',
  'page.convertedResult': '转换结果',
  'page.yourTimeZone': '您的时区',
  'page.relative': '相对时间',

  // 相对时间翻译
  'page.relativeTime.secondsAgo': '{{seconds}} 秒前',
  'page.relativeTime.minutesAgo': '{{minutes}} 分钟前',
  'page.relativeTime.hoursAgo': '{{hours}} 小时前',
  'page.relativeTime.daysAgo': '{{days}} 天前',
  'page.relativeTime.inSeconds': '{{seconds}} 秒后',
  'page.relativeTime.inMinutes': '{{minutes}} 分钟后',
  'page.relativeTime.inHours': '{{hours}} 小时后',
  'page.relativeTime.inDays': '{{days}} 天后',

  // 什么是时间戳部分（FAQ）
  'page.faq': '常见问题 (FAQ)',
  'page.whatIsTimestamp': '什么是Unix时间戳？',
  'page.timestampIntro': 'Unix时间戳（也称为纪元时间或POSIX时间）是一种用于描述时间点的系统，表示自1970年1月1日 00:00:00 UTC（Unix纪元）以来经过的秒数（或毫秒数），不计算闰秒。这个标准在计算机和编程中被广泛使用，是表示日期和时间的简单、通用的方式。',

  'page.unixEpochTitle': 'Unix纪元 - 时间的起点',
  'page.unixEpochDesc': 'Unix纪元是1970年1月1日午夜UTC时刻。所有Unix时间戳都从这个特定时刻开始计算，使其成为全球计算机系统的通用参考点。',

  'page.timestampFormatsTitle': '时间戳格式',
  'page.secondsFormat': '秒级（10位）',
  'page.secondsFormatDesc': '标准Unix时间戳，表示自纪元以来的秒数。示例：1734598784',
  'page.millisecondsFormat': '毫秒级（13位）',
  'page.millisecondsFormatDesc': '具有毫秒精度的扩展时间戳。示例：1734598784000',

  'page.whyUseTimestampTitle': '为什么使用Unix时间？',
  'page.reason1Title': '时区独立',
  'page.reason1Desc': '时间戳表示UTC时间，在全球应用中消除时区混淆。',
  'page.reason2Title': '易于计算',
  'page.reason2Desc': '简单的算术运算即可计算时间差和持续时间。',
  'page.reason3Title': '数据库友好',
  'page.reason3Desc': '紧凑的整数存储格式，非常适合数据库索引和排序。',
  'page.reason4Title': '通用标准',
  'page.reason4Desc': '几乎所有编程语言和平台都支持。',
  'page.year2038Problem': '2038年会发生什么？（2038年问题）',
  'page.year2038Content': '2038年问题（也称为Y2038或Unix千年虫）是指32位Unix时间戳将会溢出的时刻。在2038年1月19日03:14:07 UTC时，有符号32位整数将达到其最大值（2,147,483,647）并回绕为负数。使用64位时间戳的现代系统不受影响，可以表示数十亿年后的日期。',

  // 编程示例部分
  'page.codingExamples': '如何在不同编程语言中获取当前时间戳',
  'page.codeCheatSheet': 'Unix时间戳代码速查表（按语言分类）',
  'page.howToGetTimestamp': '如何获取当前时间戳',
  'page.convertToDate': '时间戳转日期对象',
  'page.convertToTimestamp': '日期转时间戳',
  'page.getCurrentTimestamp': '获取当前时间戳',
  'page.getMilliseconds': '获取毫秒级时间戳',
  'page.getSeconds': '获取秒级时间戳',

  // 时间戳转日期的示例
  'page.timestampToDateExamples': '如何将Unix时间戳转换为日期时间',
  'page.timestampToDateDesc': '学习如何在各种编程语言中将Unix时间戳转换为人类可读的日期和时间格式。无论您有秒级还是毫秒级时间戳，这些示例都会向您展示正确的转换方法。',
  'page.convertTimestampToDate': '将时间戳转换为日期',
  'page.fromMilliseconds': '从毫秒级时间戳转换',
  'page.fromSeconds': '从秒级时间戳转换',
  'page.formatOptions': '使用自定义格式',
  'page.toUTC': '转换为UTC时间',
  'page.formatDate': '格式化日期',

  // 日期转时间戳的示例
  'page.dateToTimestampExamples': '如何将日期时间转换为Unix时间戳',
  'page.dateToTimestampDesc': '学习如何在不同编程语言中将日期和时间转换为Unix时间戳。这些示例演示了如何解析日期字符串、从日期组件创建时间戳，以及处理秒级和毫秒级格式。',
  'page.convertDateToTimestamp': '将日期转换为时间戳',
  'page.fromDateString': '从日期字符串转换',
  'page.fromDateComponents': '从日期组件创建',
  'page.parseString': '解析日期字符串',
  'page.monthNote': '注意：月份从0开始',
  'page.useCalendar': '使用Calendar类',
  'page.parseFormat': '按格式解析',
  'page.fromComponents': '从时间组件创建',
  'page.currentTime': '获取当前时间戳',
  'page.fromDatetime': '从datetime字段转换',

  // 使用说明
  'page.howToUse': '如何使用时间戳转换器',
  'page.step1': '📊 当前时间戳：实时显示Unix时间戳，包括秒级（10位）和毫秒级（13位）两种格式。点击复制按钮可快速复制时间戳到剪贴板。',
  'page.step2': '🔄 时间戳转日期时间：输入一个Unix时间戳，选择是秒级还是毫秒级格式。点击转换按钮即可查看对应的日期时间，包括GMT时间、本地时区时间、ISO 8601格式和相对时间。',
  'page.step3': '📅 日期时间转时间戳：使用日期选择器选择任意日期和时间，或点击"当前时间"使用当前时刻。转换后可立即获得秒级和毫秒级两种时间戳格式。',
  'page.step4': '💡 小贴士：Unix时间戳是从1970年1月1日 00:00:00 UTC 开始计算的秒数/毫秒数。10位数字表示秒级，13位数字表示毫秒级。所有转换都是即时的，可离线使用。',

  // 相关工具
  'page.relatedTools': '相关时间工具',
  'page.relatedToolsDesc': '探索我们的其他专业时间管理工具',
  'page.timerTool': '在线计时器',
  'page.timerToolDesc': '完美适用于番茄工作法、烹饪、学习和工作休息的倒计时器',
  'page.stopwatchTool': '秒表',
  'page.stopwatchToolDesc': '高精度秒表，毫秒级准确度，适合运动训练和计时',
  'page.worldClockTool': '世界时钟',
  'page.worldClockToolDesc': '实时世界时钟，显示全球主要城市的当前时间',

  // 专业工具
  'page.specializedTools': '专业时间戳工具',
  'page.specializedToolsDesc': '探索更多专业时间戳工具，满足不同平台的需求',
  'page.discord.desc': '生成 <t:format> 代码，自动时区转换，完美适用于Discord活动和公告',
  'page.discord.topSearch': '最高搜索量',
  'page.discord.searchesPerMonth': '月搜索',
  'page.youtube.desc': '创建带时间戳的可分享YouTube链接，精确定位视频片段',
  'page.youtube.popular': '热门工具',

  // 编程语言指南
  'page.programmingGuides': '编程语言时间戳指南',
  'page.programmingGuidesDesc': '深入学习各编程语言的时间戳处理方法、函数和最佳实践',
  'page.sql.desc': 'MySQL、PostgreSQL、Oracle、SQL Server 时间戳处理',
  'page.sql.highPriority': '高优先级',
  'page.sql.searches': '搜索',
  'page.python.desc': 'datetime、time、calendar 模块完全指南',
  'page.python.popular': '热门',
  'page.javascript.desc': 'Date 对象、Day.js、date-fns 库使用指南',
  'page.javascript.common': '常用',
  'page.codeExamplesNote': '包含完整代码示例、最佳实践和常见问题解答',
};
